import type { OrderLineDiscountRecord } from '@navio/nsdk';

export const groupDiscountsByOrderLine = (discounts: OrderLineDiscountRecord[]) => {
  const map = new Map<number, OrderLineDiscountRecord[]>();
  for (const discount of discounts) {
    const existing = map.get(discount.orderLineId) ?? [];
    existing.push(discount);
    map.set(discount.orderLineId, existing);
  }
  return map;
};
